const YOUTUBE_ID_REGEX = /(?:youtube\.com\/watch\?v=|youtu\.be\/)([^"&?/\s]{11})/i;
const VIMEO_ID_REGEX = /vimeo\.com\/(?:video\/)?(\d+)/i;
const YOUTUBE_HOST_PATTERN = /(?:youtube\.com|youtu\.be|youtube-nocookie\.com)/i;
const VIMEO_HOST_PATTERN = /vimeo\.com/i;
const DIRECT_VIDEO_FILE_PATTERN = /\.(?:mp4|webm|ogg|mov|avi|mkv|m4v)(?:\?|$)/i;

/**
 * True when a PIM/BM external URL should render as embeddable video (not a raster image).
 * Merchants may configure either an external image URL or YouTube/Vimeo (or direct video file).
 *
 * @param {string|null|undefined} url
 * @returns {boolean}
 */
export const isEmbeddableVideoUrl = (url) => {
  if (!url || typeof url !== 'string') {
    return false;
  }

  const trimmed = url.trim();

  if (!/^https?:\/\//i.test(trimmed)) {
    return false;
  }

  return (
    YOUTUBE_HOST_PATTERN.test(trimmed) ||
    VIMEO_HOST_PATTERN.test(trimmed) ||
    DIRECT_VIDEO_FILE_PATTERN.test(trimmed)
  );
};

/**
 * Normalize a video URL to its provider-specific ID.
 *
 * - YouTube URL → 11-char video ID
 * - Vimeo URL   → numeric video ID
 * - Anything else (e.g. direct .mp4 URL) → returned unchanged
 *
 * @param {string} videoIdOrUrl - A YouTube/Vimeo URL, video ID, or direct video URL
 * @returns {string|null} Normalised ID or the original string; null if input is falsy
 */
export function normalizeVideoId(videoIdOrUrl) {
  if (!videoIdOrUrl || typeof videoIdOrUrl !== 'string') return null;

  const s = videoIdOrUrl.trim();

  return YOUTUBE_ID_REGEX.exec(s)?.[1] ?? VIMEO_ID_REGEX.exec(s)?.[1] ?? s;
}
